import classNames from 'classnames';

const styles = {
  container: classNames(
    'flex',
    'gap-x-6',
    'mt-4',
    'lg:flex-row',
    'flex-col',
  ),
  range: classNames(
    'grow',
    'mt-8',
  ),
  input: classNames(
    'lg:basis-[155px]',
  ),
};

export default styles;
